export function isMicroApp() {
	return Boolean((window as any).__POWERED_BY_QIANKUN__);
}
